module.exports = __webpack_public_path__ + "static/media/17.6a48f77d.jpg";